mutation chainMigration($signature: String!, $step: String!) {
  chainMigration(signature: $signature, step: $step) {
    status
    message
  }
}
